/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Inventory_LowInputs */

const vi_dashboard_manager_inventory_low = /** @type {(inputs: Dashboard_Manager_Inventory_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp hết hàng`)
};

/**

* @param {Dashboard_Manager_Inventory_LowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_inventory_low = /** @type {((inputs?: Dashboard_Manager_Inventory_LowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Inventory_LowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_inventory_low(inputs)
});